import {Injectable} from '@angular/core';
import {HttpApiService} from '../../shared/services/http-api.service';
import {HttpParams} from '@angular/common/http';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {ApiResponseModel} from '../../shared/entities/api-response.model';
import {JobTypeModel} from '../models/jobType.model';
import {JobModel} from '../models/job.model';
import {CandidateModel} from '../models/candidate.model';

@Injectable({
    providedIn: 'root'
})

export class JobService {

    constructor(
        public httpApiService: HttpApiService,
        private router: Router,
    ) {

    }

    getTable(): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpGet('jobs/index');
    }

    get(uid: string): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpGet('jobs/findOne', {uid: uid});
    }

    create(data: JobModel): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpPost('jobs/create', data);
    }

    update(data: JobModel): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpPost('jobs/update', data);
    }

    delete(data: JobModel): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpDelete('jobs/destroy', data);
    }

    getCandidatesList(uid: string): Observable<ApiResponseModel> {
        return this.httpApiService.httpGet('jobs/getCandidates', {uid: uid});
    }

    getRecommendationsList(uid: string): Observable<ApiResponseModel> {
        return this.httpApiService.httpGet('jobs/getRecommendations', {uid: uid});
    }

    makeRecommendations(jobUid: string, userUid: string): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpPost('jobs/makeRecommendation', {jobUid: jobUid, userUid: userUid});
    }

    checkUserRecommendation(jobUid: string): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpPost('jobs/checkUserRecommendation', {jobUid: jobUid});
    }

    applyToJob(jobUid: string): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpPost('jobs/applyToJob', {jobUid: jobUid});
    }


    declineJobApplication(candidate: CandidateModel): Observable<ApiResponseModel> {
        return this.httpApiService.httpPost('jobs/declineJobApplication', candidate);
    }

    acceptJobApplication(candidate: CandidateModel): Observable<ApiResponseModel> {
        return this.httpApiService.httpPost('jobs/acceptJobApplication', candidate);
    }

    getCvLink(userUid: string): Observable<ApiResponseModel> {
        return this.httpApiService.getFile('User', 'cv', userUid);
    }

}


